module.exports = __webpack_public_path__ + "static/share-image-425b6cc85bfb0dcf9993f889bd0db493.jpg";